import { EventEmitter } from "@angular/core";
import { AuthUser } from "@app/auth/model/auth-user";
import { ClareSystem } from "@app/project/model/clare-system";
import { DataErrorAction } from "@app/shared/resources/data-actions";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { User } from "@app/user/model/user";
import { Action } from "@ngrx/store";

export enum ActionTypes {
    GetLocationsByCustomer = "[CustomerLocation] Load Customer Locations",
    GetLocationsByCustomerSuccess = "[CustomerLocation] Load Customer Locations Success",
    GetLocationsByCustomerFailure = "[CustomerLocation] Load Customer Locations Failure",
    ClearLocationUsersState = "[CustomerLocation] Clear Location Users State",
    GetLocationUsers = "[CustomerLocation] Load Location Users",
    GetLocationUsersSuccess = "[CustomerLocation] Load Location Users Success",
    GetLocationUsersFailure = "[CustomerLocation] Load Location Users Failure",
    InviteUserToLocation = "[CustomerLocation] Invite UserInt To Location",
    InviteUserToLocationSuccess = "[CustomerLocation] Invite UserInt To Location Success",
    InviteUserToLocationFailure = "[CustomerLocation] Invite UserInt To Location Failure",
    GetCustomerRoleId = "[CustomerLocation] Get CustomerRole ID",
    GetCustomerRoleIdSuccess = "[CustomerLocation] Get CustomerRole ID Success",
    SendNewInvitedUserEmail = "[CustomerLocation] Send New Invited UserInt Email",
    SendNewInvitedUserEmailFailure = "[CustomerLocation] A",
    SendNewInvitedUserEmailSuccess = "[CustomerLocation] Send New Invited UserInt Success",
    SendExistingInvitedUserEmail = "[CustomerLocation] Send Existing Invited UserInt Email",
    SendExistingInvitedUserEmailFailure = "[CustomerLocation] b",
    DeleteLocationUser = "[CustomerLocation] c",
    DeleteLocationUserSuccess = "[CustomerLocation] d",
    DeleteLocationUserFailure = "[CustomerLocation] e",
    DeleteLocationUserConfirmationDismiss = "[CustomerLocation] f",
    DeleteLocationUserConfirmation = "[CustomerLocation] g",
    UpdateCustomerInviteCode = "[CustomerLocation] Update Customer Invite Code",
    GetLocationData = "[CustomerLocation] Get Location Data",
    GetLocationDataSuccess = "[CustomerLocation] Get Location Data Success",
    GetLocationDataFailure = "[CustomerLocation] Get Location Data Failure",
    UpdateLocation = "[UpdateLocation] Update Location",
    UpdateLocationSuccess = "[UpdateLocationSuccess] Update Location Success",
    UpdateLocationFailure = "[UpdateLocationFailure] Update Location Failure",
    RemoveLocation = "[CustomerLocation] Remove Location from UserInt",
    RemoveLocationConfirmation = "[CustomerLocation] Remove Location from UserInt Confirmation",
    RemoveLocationSuccess = "[CustomerLocation] Remove Location from UserInt Success",
    RemoveAllMobileUsersConfirmation = "[CustomerLocation] Remove All Mobile Users Confirmation",
    RemoveAllMobileUsersDismiss = "[CustomerLocation] Remove All Mobile Users Dismiss",
    RemoveAllMobileUsersProcess = "[CustomerLocation] Process Remove All Mobile Users",
    RemoveAllMobileUsersSuccess = "[CustomerLocation] Remove All Mobile Users Success",
}

export abstract class CustomerLocationAction implements Action {
    readonly type: ActionTypes;
    constructor(public payload: Record<string, unknown>) {}
}

export abstract class CustomerLocationSuccessAction {
    readonly type: ActionTypes;
    constructor(public result: Record<string, unknown>) {}
}

export abstract class CustomerLocationFailureAction {
    readonly type: ActionTypes;
    constructor(public error: DataServiceError<any>) {}
}

export class GetLocationsByCustomer implements CustomerLocationAction {
    readonly type = ActionTypes.GetLocationsByCustomer;

    constructor(public payload: { customerId: number }) {}
}

export class GetLocationsByCustomerFailure extends CustomerLocationFailureAction {
    readonly type = ActionTypes.GetLocationsByCustomerFailure;
}

export class GetLocationsByCustomerSuccess implements Action {
    readonly type = ActionTypes.GetLocationsByCustomerSuccess;

    constructor(public result: { claresystems: ClareSystem[]; customerId: number }) {}
}

export class GetLocationUsers implements CustomerLocationAction {
    readonly type = ActionTypes.GetLocationUsers;

    constructor(public payload: { claresystem: ClareSystem }) {}
}

export class ClearLocationUsersState implements CustomerLocationAction {
    readonly type = ActionTypes.ClearLocationUsersState;

    constructor(public payload: { claresystem: ClareSystem }) {}
}

export class GetLocationUsersFailure extends CustomerLocationFailureAction {
    readonly type = ActionTypes.GetLocationUsersFailure;
}

export class GetLocationUsersSuccess implements Action {
    readonly type = ActionTypes.GetLocationUsersSuccess;

    constructor(public result: { users: { userinfo: User }[]; claresystem: ClareSystem }) {}
}

export class InviteUserToLocation implements Action {
    readonly type = ActionTypes.InviteUserToLocation;

    constructor(public payload: { primaryUser: User; invitedUser: User; claresystem: ClareSystem; uuid: string }) {}
}

export class InviteUserToLocationFailure extends CustomerLocationFailureAction {
    readonly type = ActionTypes.InviteUserToLocationFailure;
}

export class InviteUserToLocationSuccess implements Action {
    readonly type = ActionTypes.InviteUserToLocationSuccess;

    constructor(public result: { primaryUser: User; invitedUser: User; claresystem: ClareSystem }) {}
}

export class GetCustomerRoleId implements Action {
    readonly type = ActionTypes.GetCustomerRoleId;
}

export class GetCustomerRoleIdSuccess implements Action {
    readonly type = ActionTypes.GetCustomerRoleIdSuccess;

    constructor(public result: { customerRoleId: number }) {}
}

export class SendNewInvitedUserEmail implements Action {
    readonly type = ActionTypes.SendNewInvitedUserEmail;

    constructor(public payload: { primaryUser: User; invitedUser: User; claresystem: ClareSystem }) {}
}

export class SendNewInvitedUserEmailFailure implements DataErrorAction<any> {
    readonly type = ActionTypes.SendNewInvitedUserEmailFailure;

    constructor(public error) {}
}

export class SendExistingInvitedUserEmail implements Action {
    readonly type = ActionTypes.SendExistingInvitedUserEmail;

    constructor(public payload: { primaryUser: User; invitedUser: User; claresystem: ClareSystem }) {}
}

export class SendExistingInvitedUserEmailFailure implements DataErrorAction<any> {
    readonly type = ActionTypes.SendExistingInvitedUserEmailFailure;

    constructor(public error) {}
}
export class SendNewInvitedUserEmailSuccess implements Action {
    readonly type = ActionTypes.SendNewInvitedUserEmailSuccess;
    constructor(public result: { claresystem: ClareSystem }) {}
}

export interface LocationUser {
    user?: User;
    claresystem: ClareSystem;
    userInfoId: number;
}

export interface LocationAuthUser {
    user?: AuthUser;
    claresystem: ClareSystem;
    userInfoId: number;
}

export interface RemovalUsers {
    claresystem: ClareSystem;
    onDone?: EventEmitter<any>;
}

export class RemoveLocation implements Action {
    readonly type = ActionTypes.RemoveLocation;
    constructor(public payload: LocationUser) {}
}
export class RemoveLocationConfirmation implements Action {
    readonly type = ActionTypes.RemoveLocationConfirmation;
    constructor(public payload: LocationUser) {}
}

export class RemoveAllMobileUsersConfirmation implements Action {
    readonly type = ActionTypes.RemoveAllMobileUsersConfirmation;
    constructor(public payload: RemovalUsers) {}
}

export class RemoveAllMobileUsersDismiss implements Action {
    readonly type = ActionTypes.RemoveAllMobileUsersDismiss;
}

export class RemoveAllMobileUsersProcess implements Action {
    readonly type = ActionTypes.RemoveAllMobileUsersProcess;
    constructor(public payload: RemovalUsers) {}
}

export class RemoveAllMobileUsersSuccess implements Action {
    readonly type = ActionTypes.RemoveAllMobileUsersSuccess;
    constructor(public payload: RemovalUsers) {}
}
export class RemoveLocationSuccess implements Action {
    readonly type = ActionTypes.RemoveLocationSuccess;
    constructor(public result: LocationUser) {}
}
export class DeleteLocationUser implements Action {
    readonly type = ActionTypes.DeleteLocationUser;

    constructor(public payload: LocationAuthUser) {}
}

export class DeleteLocationUserSuccess implements Action {
    readonly type = ActionTypes.DeleteLocationUserSuccess;

    constructor(public result: LocationUser) {}
}

export class DeleteLocationUserFailure implements DataErrorAction<LocationUser> {
    readonly type = ActionTypes.DeleteLocationUserFailure;
    constructor(public readonly error: DataServiceError<LocationUser>) {}
}

export class DeleteLocationUserConfirmationDismiss implements Action {
    readonly type = ActionTypes.DeleteLocationUserConfirmationDismiss;
    constructor(public payload: LocationUser & { onDone?: EventEmitter<any> }) {}
}

export class DeleteLocationUserConfirmation implements Action {
    readonly type = ActionTypes.DeleteLocationUserConfirmation;
    constructor(public readonly payload: LocationAuthUser) {}
}

export class UpdateCustomerInviteCode implements Action {
    readonly type = ActionTypes.UpdateCustomerInviteCode;

    constructor(public payload: { primaryUser: User; invitedUser: User; claresystem: ClareSystem }) {}
}

export class GetLocationData implements Action {
    readonly type = ActionTypes.GetLocationData;

    constructor(public payload: { uuid: string }) {}
}

export class GetLocationDataSuccess implements Action {
    readonly type = ActionTypes.GetLocationDataSuccess;

    constructor(public result: any) {}
}

export class GetLocationDataFailure implements Action {
    readonly type = ActionTypes.GetLocationDataFailure;

    constructor(public error: DataServiceError<any>) {}
}

export class UpdateLocation implements Action {
    readonly type = ActionTypes.UpdateLocation;

    constructor(public payload: { claresystem: ClareSystem }) {}
}

export class UpdateLocationSuccess implements Action {
    readonly type = ActionTypes.UpdateLocationSuccess;

    constructor(public result: { claresystem: ClareSystem }) {}
}

export class UpdateLocationFailure implements Action {
    readonly type = ActionTypes.UpdateLocationFailure;

    constructor(public readonly error: DataServiceError<any>) {}
}

export type Actions =
    | GetLocationsByCustomer
    | GetLocationsByCustomerSuccess
    | GetLocationsByCustomerFailure
    | ClearLocationUsersState
    | GetLocationUsers
    | GetLocationUsersSuccess
    | GetLocationUsersFailure
    | InviteUserToLocation
    | InviteUserToLocationSuccess
    | InviteUserToLocationFailure
    | GetCustomerRoleId
    | GetCustomerRoleIdSuccess
    | SendNewInvitedUserEmail
    | SendNewInvitedUserEmailFailure
    | SendNewInvitedUserEmailSuccess
    | SendExistingInvitedUserEmail
    | SendExistingInvitedUserEmailFailure
    | DeleteLocationUser
    | DeleteLocationUserSuccess
    | DeleteLocationUserFailure
    | DeleteLocationUserConfirmationDismiss
    | DeleteLocationUserConfirmation
    | UpdateCustomerInviteCode
    | GetLocationData
    | GetLocationDataSuccess
    | GetLocationDataFailure
    | UpdateLocation
    | UpdateLocationSuccess
    | UpdateLocationFailure
    | RemoveLocation
    | RemoveLocationSuccess
    | RemoveLocationConfirmation;
